import { WebGlApp } from './webgl/WebGlApp';
import { SETTINGS } from './webgl/SETTINGS';
import { RapierApp } from './rapier/RapierApp';

const FRAME_INTERVAL = 1000 / SETTINGS.fps; // フレーム間隔

export class App {
  private WebGlApp: WebGlApp;
  private RapierApp: RapierApp;
  private lastFrameTime: number = 0;

  constructor(
    webglCanvas: HTMLCanvasElement,
  ) {
    // Initialize
    this.RapierApp = new RapierApp();
    this.WebGlApp = new WebGlApp(webglCanvas, this.RapierApp.getWorld() || undefined);
  }

  /**
   * 初期化
   */
  public initialize = async (): Promise<void> => {
    await this.RapierApp.initialize();
    // WebGlAppに物理演算ワールドを設定
    const world = this.RapierApp.getWorld();
    if (world) {
      this.WebGlApp.setWorld(world);
    }
    // Animation開始
    this.animate();
  }

  private animate = (currentTime: number = 0): void => {
    // FPSを制限するための処理
    const deltaTime = currentTime - this.lastFrameTime;
    if (deltaTime >= FRAME_INTERVAL) {
      this.WebGlApp.render();
      this.lastFrameTime = currentTime;
    }
    requestAnimationFrame(this.animate);
  }

  // Helper ------------------------
}